import { render, staticRenderFns } from "./DuplicatesAdmin.vue?vue&type=template&id=1afcf30e"
import script from "./DuplicatesAdmin.vue?vue&type=script&lang=js"
export * from "./DuplicatesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports